import { render, staticRenderFns } from "./groupPurcharseOrder.vue?vue&type=template&id=32ca764e&scoped=true"
import script from "./groupPurcharseOrder.vue?vue&type=script&lang=js"
export * from "./groupPurcharseOrder.vue?vue&type=script&lang=js"
import style0 from "./groupPurcharseOrder.vue?vue&type=style&index=0&id=32ca764e&prod&lang=less&scoped=true"
import style1 from "./groupPurcharseOrder.vue?vue&type=style&index=1&id=32ca764e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca764e",
  null
  
)

export default component.exports